import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { RelazioneAtlante } from "../types"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useRelazioneAtlanteLazy() {
    const auth = useAuth()
    return useCallback((id: number) => {
        return fetchApi(`${API_URL}/admin/relazioni-atlante/${id}`, {
            method: "GET",
            responseType: "json",
            headers: {
                Authorization: `Bearer ${auth.tokens?.access}`,
            },
        }) as Promise<RelazioneAtlante>
    }, [])
}

export function useRelazioniAtlanteLazy() {
    const auth = useAuth()
    return useCallback((params: Record<string, string | number | Array<number>>) => {
        const qs = normalizeParams(params).toString()
        return fetchApi(`${API_URL}/admin/relazioni-atlante?${qs}`, {
            method: "GET",
            responseType: "json",
            headers: {
                Authorization: `Bearer ${auth.tokens?.access}`,
            },
        }) as Promise<{ results: RelazioneAtlante[] }>
    }, [])
}